// lib/supabase/client.ts
'use client'
import { createClient, type SupabaseClient } from '@supabase/supabase-js'

let client: SupabaseClient | null = null

const stub: SupabaseClient = {
  auth: {
    async getSession(){ return { data:{ session:null }, error:null } as any },
    onAuthStateChange(){ return { data:{ subscription:{ unsubscribe(){} } }, error:null } as any },
    async signInWithOAuth(){ return { data:null, error:new Error('Supabase not configured') } as any },
    async signInWithPassword(){ return { data:null, error:new Error('Supabase not configured') } as any },
    async signUp(){ return { data:null, error:new Error('Supabase not configured') } as any },
    async updateUser(){ return { data:null, error:new Error('Supabase not configured') } as any },
    async resetPasswordForEmail(){ return { data:null, error:new Error('Supabase not configured') } as any },
    async signOut(){ return { error:null } as any },
    async getUser(){ return { data:{ user:null }, error:null } as any },
  },
} as unknown as SupabaseClient

export function getSupabaseClient(): SupabaseClient {
  if (typeof window === 'undefined') return stub // SSR-safe
  if (client) return client

  const g = globalThis as any
  const url  = g.__SUPA?.url  || process.env.NEXT_PUBLIC_SUPABASE_URL
  const anon = g.__SUPA?.anon || process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
  if (!url || !anon) {
    console.warn('[supabase] missing url/anon at runtime', { url, anon: !!anon })
    return stub
  }

  client = createClient(url, anon, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    global: { headers: { Accept: 'application/json' } },
  })
  return client
}
